export type DataWithResponseInit = {
  type: 'DataWithResponseInit'
  data: unknown
  init: { status?: number; headers?: HeadersInit } | null
}

// React Router wraps action throws in a `DataWithResponseInit` (`type:"DataWithResponseInit"`, `data`,
// `init`) and hands the raw DataStrategyResult to client middleware — so the real thrown value lives at
// `.data`. RR only unwraps it later, in `convertDataStrategyResultToDataResult` (which our
// actionErrorMiddleware runs ahead of), so the wrapper leaks through to our error handling.
export function isDataWithResponseInit(value: unknown): value is DataWithResponseInit {
  return (
    typeof value === 'object' &&
    value !== null &&
    'type' in value &&
    (value as { type?: unknown }).type === 'DataWithResponseInit' &&
    'data' in value
  )
}

// Return the real thrown value React Router wrapped, or the value unchanged when it isn't wrapped.
export function unwrapDataWithResponseInit(value: unknown): unknown {
  return isDataWithResponseInit(value) ? value.data : value
}
